
import React from 'react'
import LogoGif from '../../assets/images/logo/munim-spinner.gif'
const FallbackSpinner = () => {
  return (<>
    <style>
      {`
        .fallback-spinner.app-loader {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      `}
    </style>
    <div className='fallback-spinner app-loader w-100'>
      <img src={LogoGif}  alt="Loading..." width="300" height="300" />
    </div></>
  )
}

export default FallbackSpinner
